<template>
  <v-container>
    <v-row>
      <v-col>
        <v-btn
          to="/suppliers/create"
          small
        >
          <v-icon small>mdi-plus</v-icon>
          New supplier
        </v-btn>
      </v-col>
    </v-row>

    <app-search
      :attribute_list="search_attribute"
      @setSearchParam="setSearchParam"
    />

    <app-data-table
      :list_name="'supplier'"
      :header_list="headers"
      :attribute_list="attribute_list"
      :search_param="search_param"
      :url="`/suppliers`"
    />
  </v-container>
</template>

<script>
export default {
  name: "SupplierList",
  components: {
    AppDataTable: () => import('../../../components/AppDataTable'),
    AppSearch: () => import('../../../components/AppSearch'),
  },
  data: () => ({
    headers: [
      { text: 'Id', value: 'id' },
      { text: 'Name', value: 'name' },
      { text: 'Branch', value: 'branch' },
      { text: '', value: 'actions', sortable: false }
    ],
    search_attribute: ['name', 'branch'],
    search_param: '',
    attribute_list: ['id', 'name', 'branch'],
  }),
  methods: {
    setSearchParam (val) {
      this.search_param = val
    }
  },
};
</script>
